import httpClient from './httpClient';

const END_POINT = '/api/users';

const getAllUsers = () => httpClient.get(END_POINT);
const getAllClientWithoutPerpage = () => httpClient.get('/api/clients/list');
const getAllClients = (perPage, page, sort, filterList) =>
    httpClient.get(
        '/api/clients/list' +
        '?itemsPerPage=' +
        perPage +
        '&page=' +
        page +
        sort +
        filterList
    );
const getAllCommercials = (perPage, page, sort, filterList) =>
    httpClient.get(
        '/api/commercials/list' +
        '?itemsPerPage=' +
        perPage +
        '&page=' +
        page +
        sort +
        filterList
    );
const getClientById = id => httpClient.get('/api/clients/' + id);
const getUser = user_id => httpClient.get(END_POINT + '/' + user_id);
const getCommecial = user_id => httpClient.get(`/api/commercials/${user_id}`);
const updateUser = (userData, id) =>
    httpClient.put(END_POINT + '/' + id, userData);
const updateClient = (userData, id) => httpClient.put(`/api/users/${id}/reset-password`, userData);
const updateCommercial = (commercial, id) => httpClient.put('/api/commercials/' + id, commercial);
const deleteUser = id => httpClient.put('/api/user/delete', {id});
const verifEmail = email => httpClient.post('/api/users/verif-email', {email});

const inviteUser = (name, email) =>
    httpClient.post(END_POINT + '/invite-user', {name, email});
const addCommercial = commercial => httpClient.post('/api/commercials/add', commercial);
const addClient = (subscription, voucher) => httpClient.post('/api/client/add', {subscription, voucher});
const editClient = (client, voucher, id) => httpClient.put('/api/client/update/' + id, {client, voucher, id});
const updateDomainPackClient = (idSelectedDomain,idSelectedPack, userId) =>
    httpClient.put('/api/client/updatePackDomain', {idSelectedDomain, idSelectedPack, userId});
const registerUser = (firstName, lastName, email, password, retypedPassword, state,phone, phoneNumberCode, code, idSelectedDomain, idSelectedPack, countryCode) =>
    httpClient.post('/api/users/register', {
        firstName,
        lastName,
        email,
        password,
        retypedPassword,
        state,
        phone,
        phoneNumberCode,
        code,
        idSelectedDomain,
        idSelectedPack,
        countryCode

    });
const addUserByAdmin = (userData, state) => httpClient.post('/api/clients', userData, state);
const loginUser = (email, password) =>
    httpClient.post('/api/login_check', {email, password});
const socialLoginUser = (provider, token) =>
    httpClient.post('/api/connect/verify', {provider, token});
const forgetPasswordUser = email =>
    httpClient.post(END_POINT + '/forgot-password', {email});
const recoveryCodeCheck = code =>
    httpClient.get(END_POINT + '/forgot-password/check/' + code);
const forgetPasswordChange = (newPassword, newRetypedPassword, code) =>
    httpClient.post(END_POINT + '/forgot-password/change/' + code, {
        newPassword,
        newRetypedPassword
    });
const getClient = confirmationToken =>
    httpClient.get(`/api/clients/confirmation-code/${confirmationToken}`);
const validateUser = (formComponent, idSelectedDomain, idSelectedPack) =>
    httpClient.post(END_POINT + '/confirm', {formComponent, idSelectedDomain, idSelectedPack});
const getVerifPassword = (email, password) => httpClient.post(END_POINT + '/get-password', {email, password});

const setEnabledConfirmationUser = confirmationToken =>
    httpClient.post(END_POINT + '/confirmation-code', {confirmationToken});
export {
    getAllUsers,
    getUser,
    inviteUser,
    registerUser,
    loginUser,
    socialLoginUser,
    forgetPasswordUser,
    recoveryCodeCheck,
    forgetPasswordChange,
    deleteUser,
    getClient,
    getCommecial,
    validateUser,
    updateUser,
    getAllClients,
    getAllCommercials,
    addCommercial,
    addUserByAdmin,
    updateCommercial,
    updateClient,
    getAllClientWithoutPerpage,
    addClient,
    getVerifPassword,
    setEnabledConfirmationUser,
    editClient,
    verifEmail,
    getClientById,
    updateDomainPackClient
};
